import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileNav from './MobileNav';
import RegistrationBanner from './RegistrationBanner';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // Sincronização Silenciosa: Regista o utilizador como usuário do portal
          await setDoc(doc(db, 'usuarios_portal', user.uid), {
            email: user.email,
            displayName: user.displayName || '',
            lastAccess: serverTimestamp()
          }, { merge: true });
        } catch (err) {
          console.warn("Silent sync skip");
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="app-layout">
      <RegistrationBanner />
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
      <MobileNav />
    </div>
  );
};

export default Layout;
